import { ConfirmationModalData, NotificationModalData, SiteErrorData } from '@/types';
import { ModalType } from './enums';

const ViewVersionModal = (): NotificationModalData => ({
  heading: 'View version only',
  message: 'You are viewing the portal as another user and can not make any edits.'
});

const PopupBlockerModal = (): NotificationModalData => ({
  heading: 'Popup blocked',
  message: 'A popup blocker may be preventing the application from opening the document. If you have a popup blocker, try disabling it to open the window.'
});

const DocumentActionModal = (
  documentTitle: string,
  modalType: ModalType.DOCUMENT_DOWNLOAD | ModalType.DOCUMENT_PREVIEW
): NotificationModalData => (modalType === ModalType.DOCUMENT_PREVIEW ? {
  heading: `"${documentTitle}"`,
  message: 'document opened in a new tab.'
} : {
  heading: `"${documentTitle}"`,
  message: 'document downloaded.'
});

const RemoveCoByerModal = (): ConfirmationModalData => ({
  title: 'Remove from home',
  description: 'Are you sure you want to remove yourself as a co-buyer? You will no longer have access to information for this home.',
  cancelActionText: 'No',
  confirmActionText: 'Yes'
});

const CoBuyerRemovedFromHomeModal = (): ConfirmationModalData => ({
  title: 'Remove from home',
  description: 'You have removed yourself as a co-buyer. You will no longer have access to information for this home and will be logged out.'
});

const CancelAppointmentModal = (): ConfirmationModalData => ({
  title: 'Cancel Appointment',
  description: 'Are you sure you want to cancel this appointment?',
  cancelActionText: 'No',
  confirmActionText: 'Yes'
});

const AppointmentCancelledModal = (): ConfirmationModalData => ({
  title: 'Cancel Appointment',
  description: 'Appointment has been canceled.'
});

const CancelMessageModal = (): ConfirmationModalData => ({
  title: 'Cancel Message',
  description: 'Are you sure you want to erase that message?',
  cancelActionText: 'No',
  confirmActionText: 'Yes'
});

const RemoveAttachmentModal = (): ConfirmationModalData => ({
  title: 'Remove attachment',
  description: 'Are you sure you want to remove this attachment?',
  cancelActionText: 'No',
  confirmActionText: 'Yes'
});

const ContactDreesModal = (): ConfirmationModalData => ({
  title: ' Contact Drees Team ',
  description: 'Please contact a Drees Team Member for assistance.'
});

const NotificationModal = (documentTitle = '') => ({
  ViewVersionModal: ViewVersionModal(),
  PopupBlockerModal: PopupBlockerModal(),
  DocumentDownloadModal: DocumentActionModal(documentTitle, ModalType.DOCUMENT_DOWNLOAD),
  DocumentPreviewModal: DocumentActionModal(documentTitle, ModalType.DOCUMENT_PREVIEW),
  ContactDreesTeamModal: ContactDreesModal()
});

const ConfirmationModal = {
  RemoveCoBuyer: RemoveCoByerModal(),
  CoBuyerRemoved: CoBuyerRemovedFromHomeModal(),
  CancelAppointment: CancelAppointmentModal(),
  AppointmentCanceled: AppointmentCancelledModal(),
  CancelMessage: CancelMessageModal(),
  RemoveAttachment: RemoveAttachmentModal()
};

const PageNotFound = (): SiteErrorData => ({
  code: 404,
  heading: 'Page Not Found',
  message: 'Sorry, this page cannot be found.',
  linkText: 'Go to My Drees Home',
  link: '/signin'
});

const GeneralSiteError = (): SiteErrorData => ({
  code: 500,
  heading: 'Internal Server Error',
  message: 'Sorry, your request could not be completed at this time. Please try again later or contact your Drees representative for assistance.',
  linkText: 'Go to My Drees Home',
  link: '/signin'
});

export { NotificationModal, ConfirmationModal, PageNotFound, GeneralSiteError };
